import { apiClient } from './client';
// Company tracking API functions
export const trackingApi = {
    // Get the company tracking config (TrackingId, Enabled, ScriptUrl)
    getCompanyTracking: (clientCompanyId) => apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Tracking`),
    // Toggle the Enabled flag — server returns the updated DTO
    patchCompanyTracking: (clientCompanyId, dto) => apiClient.patch(`/api/ClientCompanies/${clientCompanyId}/Tracking`, dto),
};
